﻿/**
 * strip-line-breaks.filter
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add filter */
	angular.module('nha.portal').filter('stripLineBreaks', stripLineBreaks);

	/** implementation */
	function stripLineBreaks() {
		return function(text) {
			return text ? String(text).replace('<br />', ' ') : '';
		};
	}
})();